import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import {
  transformAddressData,
  initialFormValues
} from 'common/components/address/helpers';
// eslint-disable-next-line import/no-cycle
import { Modal, FormError } from 'common/components/layout';
import { convertStringToInteger } from 'common/helpers/numberHelper';
import {
  getCustomerAddress,
  editCustomerAddress
} from 'redux/customerAddresses/actions';

import AddEditForm from './components/AddEditForm';
import { validateEdit } from './validators';

class EditModal extends Component {
  componentDidMount() {
    const { props } = this;
    const { addressId } = this.props;
    props.getCustomerAddress(addressId);
  }

  handleSubmit = (form) => {
    const { props } = this;
    const { addressId } = this.props;
    const data = transformData(form);
    const successFunction = (address) => {
      props.onEditAddress(address);
    };
    props.editCustomerAddress(addressId, data, successFunction);
  };

  render() {
    const { settings, customerAddresses } = this.props;
    const { handleSubmit, object, form } = this.props;
    const { onCloseModal, cancelFunction = onCloseModal } = this.props;
    if (!settings.data || !customerAddresses.data) {
      return (
        <Modal title="Edit Address" onCloseModal={onCloseModal}>
          &nbsp;
        </Modal>
      );
    }
    const { props } = this;

    const addressArr = Object.keys(customerAddresses.data);
    const isFirstAddress = addressArr.length === 1 || false;

    return (
      <Modal title="Edit Address" onCloseModal={onCloseModal} formName={form}>
        <FormError formName={form} />
        <AddEditForm
          onSubmit={handleSubmit(this.handleSubmit)}
          saveButtonText="Update Address"
          object={object}
          changeFunction={props.change}
          onCancelFunction={cancelFunction}
          isFirstAddress={isFirstAddress}
          settings={settings}
        />
      </Modal>
    );
  }
}

const transformData = (values) => {
  const data = transformAddressData(values);
  data.isDefault = values.isDefault || false;
  return data;
};

const validate = (values, ownProps) => {
  const data = transformData(values);
  data.birthDay = values.birthDay && convertStringToInteger(values.birthDay);
  data.birthMonth =
    values.birthMonth && convertStringToInteger(values.birthMonth);
  data.birthYear = values.birthYear && convertStringToInteger(values.birthYear);
  const errors = validateEdit(data, ownProps.settings);
  return errors;
};

const mapStateToProps = (state, ownProps) => {
  let formValues = {};
  if (state.customerAddress.data) {
    const address = state.customerAddress.data[ownProps.addressId];
    formValues = initialFormValues(address);
  }
  return {
    initialValues: formValues,
    object:
      state.customerAddress.data &&
      state.customerAddress.data[ownProps.addressId],
    isFetching: state.customerAddress.isFetching,
    settings: state.setting,
    customerAddresses: state.customerAddress
  };
};

EditModal = reduxForm({
  form: 'EditModal',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(EditModal);

export default connect(mapStateToProps, {
  getCustomerAddress,
  editCustomerAddress
})(EditModal);
